var moduleMap = {
	"./AskAi": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(4272)]).then(() => (() => ((__webpack_require__(74272)))));
	},
	"./ContentList": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(6494)]).then(() => (() => ((__webpack_require__(16494)))));
	},
	"./DirectoryEntries": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(7144)]).then(() => (() => ((__webpack_require__(77144)))));
	},
	"./MicroApp": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(5282)]).then(() => (() => ((__webpack_require__(5282)))));
	},
	"./MyTrainings": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(6602)]).then(() => (() => ((__webpack_require__(56602)))));
	},
	"./VideoPlayer": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(2923)]).then(() => (() => ((__webpack_require__(2923)))));
	},
	"./VideoPicker": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(414)]).then(() => (() => ((__webpack_require__(60414)))));
	},
	"./AiAgentChat": () => {
		return Promise.all([__webpack_require__.e(7788), __webpack_require__.e(18)]).then(() => (() => ((__webpack_require__(90018)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});